import { API_ENDPOINTS } from '../config/constants';
import { generateToken, TOKEN_HEADER } from './tokenUtils';

async function request(url, options) {
  const response = await fetch(url, options);
  let payload;
  try {
    payload = await response.json();
  } catch {
    throw new Error('The server returned an unreadable response. Please retry.');
  }
  if (!response.ok || payload.success !== true) {
    const error = new Error(payload.message || payload.error || payload.errors?.[0]?.msg || 'Request failed. Please retry.');
    error.status = response.status;
    throw error;
  }
  return payload.data;
}

export const loadSubscriptions = () => request(API_ENDPOINTS.SUBSCRIPTIONS, { cache: 'no-store' });

export const saveSubscriptions = catalogue => request(API_ENDPOINTS.SUBSCRIPTIONS, {
  method: 'PUT',
  headers: { 'Content-Type': 'application/json', [TOKEN_HEADER]: generateToken() },
  body: JSON.stringify(catalogue)
});

export const createSubscriberSubscription = (form, subscriptionType, offer = 'monthly') => request(API_ENDPOINTS.SUBSCRIPTION_CREATE, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    name: form.name.trim(), mobile: form.mobile.trim(), email: form.email.trim(),
    consent: form.consent, subscriptionType, offer
  })
});
